import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ResponseData } from '@core/types/types';

type BiometricValidationRequest = {
  isPatientAssisted: false,
  beneficiaryId: number;
  providerSlug: string;
  biometricType: 'LECTURA_HUELLA' | 'LECTURA_FACIAL';
  img: string;
} | {
  isPatientAssisted: true,
  identificationNumber: string;
  biometricType: 'LECTURA_HUELLA' | 'LECTURA_FACIAL';
  img: string;
};

type BiometricValidationResponse =
  | { biometricValidationId: string; status: 'VERIFICATION_SUCCESS' }
  | { status: 'VERIFICATION_ERROR'; statusId: number; statusMessage: string };

@Injectable({
  providedIn: 'root',
})
export class BiometricService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  validateBiometric(
    data: BiometricValidationRequest,
    token: string
  ): Observable<ResponseData<BiometricValidationResponse>> {
    return this.http.post(`${this.apiUrl}/biometria/validar`, data, {
      headers: { token: token },
    }) as Observable<ResponseData<BiometricValidationResponse>>;
  }
}
